import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react'
import { useToasts } from '../../store/toast'

export function Toaster() {
  const toasts = useToasts((s) => s.toasts)
  const dismiss = useToasts((s) => s.dismiss)

  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-[60] flex flex-col items-center gap-2 p-4 pb-[max(1rem,env(safe-area-inset-bottom))] sm:items-end sm:p-6"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div key={t.id} className="toast pointer-events-auto" role="status">
          {t.tone === 'success' && (
            <CheckCircle2 className="h-5 w-5 text-[#7FE0B0]" />
          )}
          {t.tone === 'error' && (
            <AlertCircle className="h-5 w-5 text-[#FFA3B4]" />
          )}
          {t.tone === 'info' && <Info className="h-5 w-5 text-vault-300" />}
          <span>{t.message}</span>
          <button
            type="button"
            className="-mr-1 grid h-8 w-8 place-items-center rounded-lg text-muted hover:text-white"
            aria-label="Dismiss"
            onClick={() => dismiss(t.id)}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  )
}
